import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

import styles from './styles.module.scss';
import cn from 'classnames';
import { Button, Logo } from '@infologistics/frontend-libraries';
import { Instance } from '@app/const/consts';
import { IApplicationState } from '@app/store/types/commonTypes';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { getDfLogoSrc } from '@app/utils/utils';

interface IApp {
  ios: string;
  android: string;
}

type IUrls = {
  [key in Instance]: IApp;
};

const URLS: IUrls = {
  [Instance.RUSSIAN]: {
    ios: 'https://apps.apple.com/ru/app/docuforce/id1583931741',
    android: 'https://play.google.com/store/apps/details?id=ru.infologistics.docuforce',
  },
  [Instance.BRASIL]: {
    ios: 'https://apps.apple.com/br/app/docuforce/id1658324329',
    android: 'https://play.google.com/store/apps/details?id=br.infologistics.docuforce',
  },
  [Instance.GLOBAL]: {
    ios: 'https://apps.apple.com/us/app/docuforce/id1658326888',
    android: 'https://play.google.com/store/apps/details?id=global.infologistics.docuforce',
  },
  [Instance.SOUTH_AFRICA]: {
    ios: 'https://apps.apple.com/us/app/docuforce/id1658326888',
    android: 'https://play.google.com/store/apps/details?id=global.infologistics.docuforce',
  },
  [Instance.VIETNAMESE]: {
    ios: 'https://apps.apple.com/vn/app/docuforce/id6749271685',
    android: 'https://play.google.com/store/apps/details?id=vi.infologistics.docuforce',
  },
};

// const SESSION_STORAGE_KEY = BrowserStorage.APP_DOWNLOAD;

export const MobileAppNotification = () => {
  const [showMobile, setShowMobile] = useState(false);
  // const instance = (getDataFromLocalStorage(BrowserStorage.INSTANCE) as Instance) ?? Instance.GLOBAL;
  const { instance } = useSelector((state: IApplicationState) => state.utils);
  const { t } = useTranslation(['common']);

  // const checkBrowser = false;
  // const checkBrowser = sessionStorage.getItem(SESSION_STORAGE_KEY);
  const userAgent = navigator.userAgent;
  const isIOS = /iPhone|iPad|iPod/i.test(userAgent);
  const isAndroid = /Android/i.test(userAgent);
  const isMobile = isIOS || isAndroid;
  const app = isIOS ? 'ios' : 'android';

  const APP_URL = URLS[instance][app];

  useEffect(() => {
    if (isMobile) {
      setShowMobile(true);
      // sessionStorage.setItem(SESSION_STORAGE_KEY, 'checked');
    }
  }, [isMobile]);

  const handleClose = () => {
    setShowMobile(false);
  };

  const handleClickNotification = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
  };

  const handleDownload = () => {
    window.open(APP_URL);
  };

  const defaultLogoSrc = getDfLogoSrc();

  return (
    <>
      {showMobile &&
        createPortal(
          <div className={styles.container} onClick={handleClose}>
            <div className={cn(styles.notification, 'd-flex flex-column full-width')} onClick={handleClickNotification}>
              <div className={cn('d-flex justify-content-center', styles.logo)}>
                <Logo src={defaultLogoSrc} alt='docuForce' />
              </div>
              <div className='d-flex justify-content-center full-width'>
                <div className={cn('d-flex flex-column', styles.notification__container)}>
                  <div>{t('common:mobileNotification.title')}</div>
                  <div>{t('common:mobileNotification.download')}</div>
                </div>
              </div>
              <div className='d-flex justify-content-center full-width'>
                <div className={cn('d-flex flex-column ', styles.notification__container, styles.notification__buttons)}>
                  <Button
                    size='large'
                    externalClass={cn(styles.notification__buttons__item, 'full-width')}
                    onClick={handleDownload}
                    theme='primary'
                  >
                    {t('common:download')}
                  </Button>
                  <Button size='large' externalClass={cn(styles.notification__buttons__item, 'full-width')} onClick={handleClose}>
                    {t('common:cancel')}
                  </Button>
                </div>
              </div>
            </div>
          </div>,
          document.body,
        )}
    </>
  );
};
